module.exports = __webpack_public_path__ + "static/media/screen_distance_sketch.06aeec99.png";